import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { useCurrentDatapointContext } from "./use-current-datapoint-context";
import { globalQueryStateSelector } from "./widget-data/use-datapoints";
import { DatapointAllowedDimensionsResponseFromJSON, EntityType, getDatapointsAllowedDimensions } from "api/ux/src";
import { objectToHash } from "common/object-helper";
import { useCurrentDashboardOptions } from "components/workspaces/hooks/use-current-dashboard";
export const useGetDatapointsAllowedDimensions = () => {
    const currentDashboardOptions = useCurrentDashboardOptions();
    const currentContext = useCurrentDatapointContext();
    const requestParameters = {
        context: currentContext ?? EntityType.Asset,
        isMyPosition: Boolean(currentDashboardOptions && currentDashboardOptions.enabled && currentDashboardOptions.selectedInvestorId)
    };
    const dataKey = objectToHash(requestParameters);
    const request = requestParameters
        ? getDatapointsAllowedDimensions(requestParameters, { queryKey: `GetDatapointsalloweddimensions-${dataKey}`,
            transform: (body) => {
                if (body) {
                    // eslint-disable-next-line new-cap
                    return { DatapointsAllowedDimensions: { [dataKey]: DatapointAllowedDimensionsResponseFromJSON(body) } };
                }
                return {};
            } })
        : null;
    const [, ForceRefresh] = useRequest(request);
    const globalQueryState = useSelector((state) => globalQueryStateSelector(state, "GetDatapointsalloweddimensions", dataKey), isEqual);
    const allowedDimensions = useSelector((state) => state.entities.DatapointsAllowedDimensions[dataKey]?.datapointAllowedDimensions || [], isEqual);
    return [allowedDimensions, globalQueryState, ForceRefresh];
};
